import createStore from "@common/store"
import config from "@/edita.config.js"

const router = createStore(config)

export default router
